import { Col, Row } from "react-bootstrap";
import { compose, withState } from "recompose";

import BudgetCategoryItemForm from "./BudgetCategoryItemForm";
import BudgetItemBackupForm from "./BudgetItemBackupForm";
import BudgetItemForm from "./BudgetItemForm";
import Button from "../../elements/CustomButton/CustomButton";
import { FormattedMessage } from "react-intl";
import NotificationProvider from "../../elements/NotificationContent/Notifications";
import Queries from "../../queries/queries2";
import React from "react";
import SideModal from "../../elements/Modal/SideModal";
import _ from "lodash";
import { graphql } from "react-apollo";
import moment from "moment";

import { fixDateToDataBase } from "../../tools/formatDate";

class CreateBudgetItemsBackupSideModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        company: { id: props.companyId },
        dateDebut: moment().startOf("month"),
        name: `Budget_${moment().year()}_${moment().month() + 1}`,
        observations: ""
      }
    };
  }

  save = async values => {
    this.props.setWorkInProgress(true);

    const dateDebutFixed = fixDateToDataBase(values.dateDebut);

    const variables = {
      companyId: values.company.id,
      name: values.name,
      dateDebut: dateDebutFixed,
      observations: values.observations
    };

    console.log("createBudgetItems", variables);
    try {
      const res = await this.props
        .createBudgetItemsBackup({
          variables
          //   refetchQueries: [
          //     {
          //       query: Queries.getClientsForBudget,
          //       variables: { companyId: values.company.id, tiersId: "" }
          //     }
          //   ]
        })
        .then(
          r => {
            console.log("r", r);

            //   if (!!!this.props.goPreviousBudget && !!!this.props.goNextBudget) {
            this.props.close();
          }
          //   }
        );

      console.log("res", res);
      this.props.setWorkInProgress(false);

      this.sendSuccessCreateNotification();
    } catch (e) {
      this.props.setWorkInProgress(false);
      console.log(e);
      this.sendFailureCreateNotification();
    }
  };

  sendSuccessCreateNotification() {
    let notif = NotificationProvider.getSuccessNotification();
    notif.message = <FormattedMessage id="ids_budgetBackupHasBeenCreated" />;
    if (this.props.sendNotification) this.props.sendNotification(notif);
  }

  sendFailureCreateNotification() {
    let notif = NotificationProvider.getFailureNotification();
    notif.message = (
      <FormattedMessage id="ids_budgetBackupCreateFailed_notification" />
    );
    if (this.props.sendNotification) this.props.sendNotification(notif);
  }

  close = () => {
    console.log("close.state", this.state);
    // this.setState({ dirty: false });
    this.props.close();
  };

  render = () => {
    const {
      title,
      sideModalVisible,
      companyId,
      sendNotification,
      intl,
      locale
    } = this.props;

    const values = {
      ...this.state.initialValues,
      companyId
    };

    return (
      <SideModal
        title={title}
        width="wide"
        visible={sideModalVisible}
        handleClose={this.close}
        children={
          <React.Fragment>
            <BudgetItemBackupForm
              // disabled={!!cloneFrom}
              sendNotification={sendNotification}
              companyId={companyId}
              values={values}
              // updateState={state => {
              //   console.log("update state", state);
              //   this.setState({ ...state,  });
              // }}
              goBack={this.close}
              save={this.save}
              workInProgress={this.props.workInProgress}
              cancel={this.close}
              intl={intl}
            />
          </React.Fragment>
        }
      />
    );
  };
}

const workInProgress = withState("workInProgress", "setWorkInProgress", () => {
  return false;
});

export default compose(
  workInProgress,
  graphql(Queries.createBudgetItemsBackup, { name: "createBudgetItemsBackup" })
  //   graphql(Queries.createBudgCreateBudgetItemsBackupSideModaletCategoryItems, {
  //     name: "createBudgetCategoryItems"
  //   }),
)(CreateBudgetItemsBackupSideModal);
